import { createReducer } from '@reduxjs/toolkit'
import { setCurrentInstance, setCurrentSession, setIntegrations, setTopics } from '../actions/data'
import { Instance, Integration, Session, Topic } from '../../types/data'

interface DataReducer {
    currentSession: Session | null
    currentInstance: Instance | null
    topics: Topic[] | null
    integrations: Integration[] | null
}

const initialState: DataReducer = {
    currentSession: null,
    currentInstance: null,
    topics: null,
    integrations: null,
}

const dataReducer = createReducer<DataReducer>(initialState, (builder) => {
    builder.addCase(setCurrentSession, (state, action) => {
        state.currentSession = action.payload
    })
    builder.addCase(setCurrentInstance, (state, action) => {
        state.currentInstance = action.payload
    })
    builder.addCase(setTopics, (state, action) => {
        state.topics = action.payload
    })
    builder.addCase(setIntegrations, (state, action) => {
        state.integrations = action.payload
    })
})

export default dataReducer
